import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/laugh': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM389.4 397.4C351.6 435.2 301.4 456 248 456S144.4 435.2 106.6 397.4 48 309.4 48 256 68.8 152.4 106.6 114.6 194.6 56 248 56 351.6 76.8 389.4 114.6 448 202.6 448 256 427.2 359.6 389.4 397.4zM328 224C345.7 224 360 209.7 360 192S345.7 160 328 160 296 174.3 296 192 310.3 224 328 224zM168 224C185.7 224 200 209.7 200 192S185.7 160 168 160 136 174.3 136 192 150.3 224 168 224zM362.4 288H133.6C125.4 288 119.1 295 120.1 303 127.6 362.2 179 408 241.2 408H254.8C317 408 368.4 362.2 375.9 303 376.9 295 370.6 288 362.4 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/laugh.js
// module id = xZKb
// module chunks = 144